angular.module 'filters'
  .filter 'formatDateTime', ($filter) -> (input) ->
    if input
      $filter('date') input, 'medium'
